import React from 'react';
import i18next from 'i18next';
import ErrorList from './errors.json';
import Alert from '../../util/alert';

class Errors {
  static async show(error, title) {
    const detail = ErrorList.find((e) => e.codes.includes(error.code)) || {
      is_visible: true,
      message: {
        title: '',
        body: '',
      },
    };

    const titleText =
      (i18next.exists(`errors.messages.${detail.handle}.title`) &&
        `errors.messages.${detail.handle}.title`) ||
      (title?.length > 0 && title) ||
      'errors.title_default';
    const detailText =
      (i18next.exists(`errors.messages.${detail.handle}.body`) &&
        `errors.messages.${detail.handle}.body`) ||
      (error.code ? 'errors.message_default' : error.message);
    const moreInfo = (t) => (
      <table style={{ border: 'none', fontSize: '11px', userSelect: 'text', textAlign: 'left' }}>
        <tr>
          <td style={{ width: '100px', verticalAlign: 'top' }}>
            <b>{t('errors.more_info.http_code')}</b>
          </td>
          <td style={{ verticalAlign: 'top' }}>{error.httpStatus || '(none)'}</td>
        </tr>
        <tr>
          <td style={{ width: '100px', verticalAlign: 'top' }}>
            <b>{t('errors.more_info.error_code')}</b>
          </td>
          <td style={{ verticalAlign: 'top' }}>{error.code || '(none)'}</td>
        </tr>
        <tr>
          <td style={{ width: '100px', verticalAlign: 'top' }}>
            <b>{t('errors.more_info.server_message')}</b>
          </td>
          <td style={{ verticalAlign: 'top' }}>
            {error.serverMessage || error.message || '(none)'}
          </td>
        </tr>
        <tr>
          <td style={{ width: '100px', verticalAlign: 'top' }}>
            <b>{t('errors.more_info.request_id')}</b>
          </td>
          <td style={{ verticalAlign: 'top' }}>{error.requestID || '(none)'}</td>
        </tr>
        <tr>
          <td style={{ width: '100px', verticalAlign: 'top' }}>
            <b>{t('errors.more_info.error_message')}</b>
          </td>
          <td style={{ verticalAlign: 'top' }}>{error.message || '(none)'}</td>
        </tr>
      </table>
    );
    // Show error
    await Alert.notifyDetail(
      titleText,
      detailText,
      error.code && moreInfo,
      'errors.action_accept',
      'errors.action_more_info'
    );
  }
}

export default Errors;
